var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-12 columns profile-forms-container"})
}
var staticRenderFns = []

export { render, staticRenderFns }